var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2092_57369)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0556641,
    y: 0.592773,
    width: 106,
    height: 71,
    fill: "#D9E021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0067 13.0887C38.7309 11.9843 40.5686 11.0895 42.4674 10.378V61.7718C38.8837 60.4361 35.6972 58.5199 32.921 55.9969C30.1492 53.4739 27.9842 50.4751 26.4128 47.0355C24.8414 43.574 24.0557 39.9292 24.0557 36.0924C24.0557 29.4444 26.5219 23.233 30.804 18.3354L33.0738 23.5473C31.6115 25.6294 30.5639 27.7552 29.9485 29.9464C28.7481 34.0932 28.7917 38.2181 30.0576 42.2864C30.6469 44.2026 31.5199 46.1014 32.6984 47.974C33.8988 49.8291 35.3174 51.4529 37.0023 52.8279V13.0887H37.0067Z",
    fill: "#224720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9261 39.89L50.8963 63.5878C49.6305 63.5048 48.2773 63.339 46.8325 63.0683L45.2393 9.4876C47.3563 8.96817 49.1721 8.65388 50.7217 8.59277V34.5603L52.9261 19.0121L55.1304 34.5603V8.61023C57.051 8.73682 58.8887 9.04674 60.6129 9.52689L58.9542 63.0683C57.732 63.2997 56.4006 63.483 54.9558 63.5878L52.9261 39.89Z",
    fill: "#224720"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3667 10.3605C64.6544 10.797 66.1865 11.526 67.9761 12.5911C69.7658 13.6518 71.2979 14.7387 72.5856 15.8823C73.9169 17.0696 75.1828 18.4446 76.3876 20.0291C77.5879 21.6136 78.4828 23.0497 79.0502 24.3243V47.8125C78.2863 49.541 77.1514 51.274 75.6848 53.0243C74.2225 54.7747 72.6031 56.3156 70.8352 57.6731C69.7658 58.5068 68.4345 59.3405 66.8587 60.1961C65.3091 61.0298 64.1305 61.5492 63.3623 61.7369V10.3605H63.3667ZM73.5896 24.7826C71.9527 22.4255 70.3769 20.6358 68.8273 19.383V52.6053C70.7261 51.0426 72.3237 49.1875 73.5896 47.0006V24.7826Z",
    fill: "#224720"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2092_57369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 71,
    fill: "white",
    transform: "translate(0.0556641 0.592773)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVwo);
export default __webpack_public_path__ + "static/media/VWO.4131397a94626f47fe3b80ec7581c81e.svg";
export { ForwardRef as ReactComponent };